import {CANCEL_OPERATION} from "../app/AppContext";
import {damsFetch} from "../app/damsFetch";
import decamelizeKeysDeep from "decamelize-keys-deep";
import {releaseJobLock} from "./uploadJobLock";

/**
 * Cancels the given operation: tags it as cancelled in the database first, and only when that succeeds removes it
 * from the list of operations, releases its upload lock and calls the callback.
 * A rejection with exactly the number 404 is handled like success: the backend answers 404 for a job that is unknown
 * or not the user's, so there is nothing left for this user to close and the row must not be stuck in the list.
 * When the request fails in any other way (HTTP error, retries exhausted or network error) nothing is changed, so the
 * operation stays in the list and the user can try again; `onError` is called with the failure reason instead.
 *
 * @param {function} appDispatch - The app dispatch function from the AppContext.
 * @param {object} operation - The operation to cancel.
 * @param {function} callback - Optional callback function that will be called with the operation ID when the operation is successfully cancelled.
 * @param {function} onError - Optional function called with the failure reason when the cancel request fails.
 */
export const cancelOperation = (appDispatch, operation, callback, onError) => {
    const closeOperation = () => {
        appDispatch({
            type: CANCEL_OPERATION,
            operation: operation
        });
        releaseJobLock(operation['jobId']);
        callback?.(operation['jobId']);
    };

    damsFetch('/jobs/file-upload', {
        method: 'POST',
        body: JSON.stringify(decamelizeKeysDeep({
            action: 'cancel',
            operation: operation
        }))
    }).then(closeOperation).catch((reason) => {
        if (reason === 404) {
            closeOperation();
            return;
        }
        onError?.(reason);
    });
};
